import { useCallback, useContext } from "react";
import { stateContext } from "./ctx";
import {generateMeshCSS} from './functions'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { icons } from "./icons";
const Favs = () => {
    const {session,setSession,setBgColor,setHue,setSchema,setShowFavs,showFavs} = useContext(stateContext)

    const deleteSaved = date => {
        let items = localStorage.getItem('MESHERSAVES');
        items = items ? JSON.parse(items) : {}
        delete items[date]
        localStorage.setItem('MESHERSAVES',JSON.stringify(items))
        setSession(Date.now())
    }

    const applySaved = ob => {
        const {schema,bgColor,hue} = ob;
        setSchema(schema)
        setBgColor(bgColor)
        setHue(hue)
    }

    const loadSaved = useCallback(()=>{
        let items = localStorage.getItem('MESHERSAVES');
        items = items ? JSON.parse(items) : {}

        
        const print = []
        for (let date in items){
            const {schema,hue,bgColor} = items[date]
        
            print.push(<div key={date} className='p-3 bg-mute-100 dark:bg-slate-800 rounded-xl'>
                <div className='h-40 rounded-md group flex items-center justify-center' style={{backgroundColor:bgColor,backgroundImage:generateMeshCSS(schema,hue)}}>
                    <div className='flex mt-3 justify-between font-semibold items-center bg-white dark:bg-slate-900 rounded-3xl gap-3 p-3 bg-opacity-20 dark:bg-opacity-20 group-hover:opacity-100 opacity-0'>
                        <div className='btn icons-white' onClick={()=>deleteSaved(date)}>{icons.close}</div>
                        <div className='p-3 px-5 cursor-pointer bg-accent text-white rounded-xl' onClick={()=>applySaved(items[date])}>Load</div>
                    </div>

                </div>
                
                
            </div>)
        }

        if (print.length === 0){
            return <div className='p-10 minititle text-center'>No Meshes saved yet :(</div>
        } else {
            return print.reverse();
        }
        

    },[session])


    const overlay = showFavs ? <div onClick={()=>setShowFavs(false)} className='absolute right-full top-0 h-full w-[9999px] z-40'></div> : []
    return <div className='w-[23.25rem] flex left-full inset-0 absolute'>
           {overlay}
        <PerfectScrollbar className='flex-1 flex'>
        <div className='flex flex-col gap-3 flex-1'>
            <div className='p-5 mt-3 bg-mute-100 dark:bg-slate-800 rounded-xl relative'>
                <div className='absolute top-0 right-0 p-5 cursor-pointer' onClick={()=>setShowFavs(false)}>{icons.close}</div>
                
                <h2 className='font-bold mb-3 text-xl text-slate-700 dark:text-slate-200'>Your Favs</h2>
                
                <p className='text-slate-400 text-sm'>Those meshes are stored in your localStorage data so they're pretty volatile, you can either clear them singularly from here or by block removing data from your browser localStorage settings.</p>
            </div>
            {loadSaved()}
            </div>
        
        </PerfectScrollbar>

    </div>
}

export default Favs;